import _extends from "@babel/runtime-corejs3/helpers/extends";
import React from 'react';
import Base from './base';
var Text = function Text(props) {
  return /*#__PURE__*/React.createElement(Base, _extends({}, props, {
    component: "span"
  }));
};
export default Text;